import React from 'react'
import { type Vector3 } from 'three'

type Props = {
  position: Vector3
  color: string
  useDepthTest?: boolean
}

export const LineDot = ({ position, color, useDepthTest = false }: Props) => {
  if (!position) return null
  return (
    <mesh position={position}>
      <sphereGeometry args={[0.15, 16, 16]} />
      <meshStandardMaterial
        color={color}
        emissive={color}
        emissiveIntensity={0.3}
        depthTest={useDepthTest}
        depthWrite={false}
      />
    </mesh>
  )
}
